<template>
  <b-container fluid>
    <section-benefits :content="sectionBenefits" />
    <section-function :content="sectionFunction" />
    <section-acum :content="sectionAcum" />
    <section-collection :content="SectionColection" />
    <section-mark :content="SectionMark" />
  </b-container>
</template>
<script>
import SectionBenefits from "@/components/userInternal/section-benefits";
import SectionFunction from "@/components/userInternal/section-function";
import SectionAcum from "@/components/userInternal/section-acum";
import SectionCollection from "@/components/userInternal/section-collection";
import SectionMark from "@/components/userInternal/section-mark";

export default {
  name: "UserInternal",
  components: {
    SectionBenefits,
    SectionFunction,
    SectionAcum,
    SectionCollection,
    SectionMark,
  },
  data: () => ({
    sectionBenefits: {
      fondo: "benefits",
    },
    sectionFunction: {
      titulo: "Cómo funcionan los <span>puntos GOX</span>",
      blocks: {
        shops: {
          titulo: "1",
          subtitulo: "Visita los<br> establecimientos<br> afiliados a GOX.",
          imagen: "shop.svg",
          active_line: true,
          padding_top: "padding-top: 4rem; margin-bottom: -9rem",
          class_titulo: "titulo-col-2",
        },
        log: {
          titulo: "2",
          subtitulo: "Identifícate como<br> cliente exclusivo GOX. ",
          imagen: "id.svg",
          active_line: true,
          padding_top: "padding-top: 4rem; margin-bottom: -9rem",
          class_titulo: "titulo-col-2",
        },
        capta: {
          titulo: "3",
          subtitulo: "Compra y acumula <br> puntos GOX.",
          imagen: "finance.svg",
          active_line: true,
          padding_top: "padding-top: 4rem; margin-bottom: -9rem",
          class_titulo: "titulo-col-2",
        },
        eleva: {
          titulo: "4",
          subtitulo:
            "Con tus puntos <br> accede a beneficios <br> exclusivos GOX.",
          imagen: "gift.svg",
          active_line: false,
          padding_top: "padding-top: 4rem; margin-bottom: -9rem",
          class_titulo: "titulo-col-2",
        },
      },
    },
    sectionAcum: {
      titulo:
        "Acumular puntos nunca fue tan fácil, comprando productos y refiriendo amigos.",
      subtitulo:
        "Canjea tus puntos GOX, comprando productos, promociones, descuentos y colecciones exclusivas.",
    },
    SectionColection: {
      titulo: "Colecciones exclusivas que premian tu lealtad",
      content:
        "Te ofrecemos productos premium que podrás canjearlos con Stickers digitales + Puntos GOX + Soles.",
      subtitulo: "Conocelas y no podras dejarlas pasar.",
    },
    SectionMark: {
      titulo: "Conoce a nuestros <br> socios GOX",
      class_color: "mark-white",
      class_titulo: "mark-titulo",
      socios: null,
    },
  }),
  mounted: function () {
    this.getBusiness();
  },
  methods: {
    getBusiness() {
      this.$store.dispatch("getBusiness").then((response) => {
        this.SectionMark.socios =
          response && response.data ? response.data : [];
      });
    },
  },
};
</script>
<style scoped></style>
